export default "__VITE_ASSET__CQhCA88m__"